import { createApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';
import { getForms, getSettings, getCountries } from "./index";
import {getMentorProcessAll, getSpecialistProcessAll} from './mentor';


export function auth(){
    return (dispatch: any) =>{
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'auth' });
        api.me({
            success:(data) =>{

                //TODO Сначала загрузим все нужные данные
                dispatch({type: types.AUTH_USER_SUCCESS, payload: data});
                dispatch(getSettings());
                dispatch(getForms());
                dispatch(getCompanies());
                dispatch(getCountries());
                if(data.is_mentor) {
                    dispatch(getMentorProcessAll());
                }
                if(data.is_specialist) {
                    dispatch(getSpecialistProcessAll());
                }
                dispatch({ type: types.LOADING_FINISH, payload: 'auth' });

                //TODO И если будет необходимо повлиять как-то на роль пользователя тут можно написать это
                if(data.isAuth && data.isAccess) {
                    console.log('Есть компании и авторизация');
                } else if( !data.isAuth && data.isAccess ) {
                    console.log('Нет авторизации');
                    api.redirect(window.location.href);
                } else if( data.isAuth && !data.isAccess ) {
                    console.log('У вас нет компаний');
                    //api.singout(window.location.href);
                } else {
                    console.log('Нет авторизации');
                    if(window.top !== window.self)
                        window.top.location.href = '/#/not-authorized';
                    else
                        window.location.href = '/#/not-authorized';
                }
            }
        })
    }
}

export function getCompanies() {
    return (dispatch: any) => {
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'companies' });
        api.getCompanies({
            success: (response ) => {
                dispatch({ type: types.FETCH_COMPANIES, payload: response });
            },
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
            }
        })
    }
}
